/**
 * @file Contains helper functions and mappings for NoResults component
 */

import translate from '../../../../i18n/translate';

import { DataType, Reason } from './types';

/**
 * Mapping between no result reason and the translations key
 */
export const mapping = new Map<`${DataType}-${Reason}`, string>([
  ['template-empty', 'TEMPLATE__GENERAL__NO_RESULT_EMPTY'],
  ['template-error', 'TEMPLATE__GENERAL__NO_RESULT_ERROR'],
  ['template-fetching', 'GENERAL__PLEASE_WAIT'],
  ['template-searching', 'GENERAL__RESULTS__EMPTY_MESSAGE'],
  ['topic-empty', 'TEMPLATE__TOPICS__NO_RESULT_EMPTY'],
  ['topic-error', 'TEMPLATE__TOPICS__NO_RESULT_ERROR'],
  ['topic-fetching', 'GENERAL__PLEASE_WAIT'],
  ['topic-searching', 'GENERAL__RESULTS__EMPTY_MESSAGE'],
]);

/**
 * Get the message to show, explaining why there's nothing to show
 *
 * @param dataType Type of data rendered inside of list
 * @param reason   The reason we want the message for
 * @returns        The (translated) message
 */
export const getMessage = (dataType: DataType, reason: Reason): string => {
  const message = mapping.get(`${dataType}-${reason}`);
  if (message === undefined) {
    reportError(`Message ${dataType}-${reason} not found`);
  }

  return message ? translate(message) : '';
};
